import { useState } from "react";
import { Box, Typography, TextField, Button } from "@mui/material";
import { Email } from "@mui/icons-material";

const SCRIPT_URL =
  "https://script.google.com/macros/s/AKfycbyrTsIrYt2uKLr5D3QKPizEv5gt7sC8IsONVe4-aFzdZwgO4pshlby3XdyqB8WJFRV82A/exec";

export default function ContactSection() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
  
    try {
      await fetch(SCRIPT_URL, {
        method: "POST",
        mode: "no-cors", // 👈 VERY IMPORTANT
        body: JSON.stringify(formData),
        headers: {
          "Content-Type": "application/json",
        },
      });
  
      alert("Message sent successfully!");
      setFormData({ name: "", email: "", message: "" });
  
    } catch (error) {
      console.error(error);
      alert("Something went wrong. Try again.");
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <Box id="contact-us" sx={{ py: 10, px: 3, textAlign: "center" }}>
      <Typography variant="h4" sx={{ mb: 1, fontWeight: 600 }}>
        Contact Us
      </Typography>

      <Typography sx={{ maxWidth: 500, mx: "auto", mb: 4 }}>
        Have questions? We'd love to hear from you.
      </Typography>

      <Box component="form" onSubmit={handleSubmit}
        sx={{ maxWidth: 500, mx: "auto", display: "flex", flexDirection: "column", gap: 3 }}
      >
        <TextField
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="Your name"
          required
          fullWidth
        />

        <TextField
          name="email"
          value={formData.email}
          onChange={handleChange}
          placeholder="your@email.com"
          type="email"
          required
          fullWidth
        />

        <TextField
          name="message"
          value={formData.message}
          onChange={handleChange}
          placeholder="Your message..."
          multiline
          minRows={5}
          required
          fullWidth
        />

        <Button
          type="submit"
          variant="contained"
          disabled={loading}
          sx={{ backgroundColor: "#2E5E3A", borderRadius: "30px", py: 1.5 }}
        >
          <Email sx={{ mr: 1 }} fontSize="small" />
          {loading ? "Sending..." : "Send Message"}
        </Button>
      </Box>
    </Box>
  );
}
